export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "1134.convertHEICToJPG.worker.937f8e62c144e06d9cdf.worker.js");
}
